import { render, staticRenderFns } from "./Access.vue?vue&type=template&id=6e8b24de&scoped=true&"
import script from "./Access.vue?vue&type=script&lang=ts&"
export * from "./Access.vue?vue&type=script&lang=ts&"
import style0 from "./Access.vue?vue&type=style&index=0&id=6e8b24de&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e8b24de",
  null
  
)

export default component.exports